import { VERTICAL_NAMES, VERTICAL_IDS } from '~/common/constants/common';

const VERTICAL_ID_NAMES = {
  [VERTICAL_IDS.homes]: VERTICAL_NAMES.homes,
  [VERTICAL_IDS.cars]: VERTICAL_NAMES.cars,
  [VERTICAL_IDS.jobs]: VERTICAL_NAMES.jobs,
  [VERTICAL_IDS.products]: VERTICAL_NAMES.products,
};

export const verticalIdToName = id => VERTICAL_ID_NAMES[id];



// WEBPACK FOOTER //
// ./app/utils/verticals.js